module.exports = __webpack_public_path__ + "img/hand-write.02cc4352.png";